<template>
    <div class="wb-navbar-green-button" :class="{'disabled': disabled}" v-on:click.stop="handleClick">
        {{text}}
    </div>
</template>

<script>
export default {
    name: 'NavbarGreenButton',
    emits: [ 'click' ],
    props: [
        'text',
        'disabled',
    ],
    methods: {
      handleClick(event) {
        if (!this.disabled) {
          this.$emit('click', event);
        }
      },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/animations.scss";

.wb-navbar-green-button {
    text-align: center;
    @include wb-c-flex-center;
    height: 40px;
    width: max-content;
    box-sizing: border-box;
    padding: 0 24px;
    border-radius: 20px;
    @include font-btn;
    color: $white;
    background-color: $green1;
    cursor: pointer;
    user-select: none;
    @include button-smooth;
}

.wb-navbar-green-button:active {
    background-color: $darkBlue;
}

.disabled{
  opacity: 0.5;
  pointer-events: none;
}
</style>
